import { createI18n } from 'vue-i18n'
import { Locale } from 'vant'

import enUS from './language/en-US/index.js'
import hiIN from './language/hi-IN/index.js'
import ptBR from './language/pt-BR/index.js'
import thTH from './language/th-TH/index.js'
import tlPH from './language/tl-PH/index.js'
import viVN from './language/vi-VN/index.js'
import zhTW from './language/zh-TW/index.js'
import indID from './language/ind-ID/index.js'
import bnBD from './language/bn-BD/index.js'
import urPK from './language/ur-PK/index.js'

const lang = storage.localStorage.get('language') || 'en-US'

const i18n = createI18n({
  legacy: false,
  warnHtmlMessage: false,
  locale: lang,
  messages: {
    'en-US': enUS,
    'hi-IN': hiIN,
    'pt-BR': ptBR,
    'th-TH': thTH,
    'tl-PH': tlPH,
    'vi-VN': viVN,
    'zh-TW': zhTW,
    'ind-ID': indID,
    'bn-BD': bnBD,
    'ur-PK': urPK,
  },
})

export function useI18n(app) {
  app.use(i18n)
}

export default i18n
